import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import Accordion from '@component/accordion';
import Icon from '@component/icon';

import ContactSales from '@component/form/contactsales';
import AdvertContent from '@component/advertise/advertcontent';

const ACCORDION_ITEMS = [
  {
    icon: <Icon type="AdvertStatic" />,
    title: I18n.t('page.advertise.guidelines.advert_static.title'),
    shortDescription: I18n.t(
      'page.advertise.guidelines.advert_static.short_description'
    ),
    content: (
      <AdvertContent
        type="static"
        image="guidelines/examples/static.jpg"
        examplesLink="http://wetransfer.info/advertgallery/set/RytsdkJBZUo2OEZ4OCtnNTJNSzFPUT09"
      />
    ),
  },
  {
    icon: <Icon type="AdvertAnimated" />,
    title: I18n.t('page.advertise.guidelines.advert_animated.title'),
    shortDescription: I18n.t(
      'page.advertise.guidelines.advert_animated.short_description'
    ),
    content: (
      <AdvertContent
        type="animated"
        image="guidelines/examples/animated.jpg"
        examplesLink="http://wetransfer.info/advertgallery/set/Z0pnYUk1MlU1Vmdha205ZDBrdXYxUT09"
        checklistItems={[
          I18n.t('page.advertise.guidelines.advert_animated.requirement_one'),
        ]}
      />
    ),
  },
  {
    icon: <Icon type="AdvertVideo" />,
    title: I18n.t('page.advertise.guidelines.advert_video.title'),
    shortDescription: I18n.t(
      'page.advertise.guidelines.advert_video.short_description'
    ),
    content: (
      <AdvertContent
        type="video"
        image="guidelines/examples/video.jpg"
        examplesLink="http://wetransfer.info/advertgallery/set/YzI4a0VaTXlQbXRyQ2grMTVCeGtKUT09"
        checklistItems={[
          I18n.t('page.advertise.guidelines.advert_video.requirement_one'),
        ]}
      />
    ),
  },
  {
    icon: <Icon type="AdvertInteractive" />,
    title: I18n.t('page.advertise.guidelines.advert_interactive.title'),
    shortDescription: I18n.t(
      'page.advertise.guidelines.advert_interactive.short_description'
    ),
    content: (
      <AdvertContent
        type="interactive"
        image="guidelines/examples/interactive.jpg"
        examplesLink="http://wetransfer.info/advertgallery/set/ZXJ4eGZ5enFHWGZUVWk1ZTFxME9Mdz09"
        checklistItems={[
          I18n.t(
            'page.advertise.guidelines.advert_interactive.requirement_one'
          ),
        ]}
      />
    ),
  },
  {
    icon: <Icon type="AdvertCustom" />,
    title: I18n.t('page.advertise.guidelines.advert_custom.title'),
    shortDescription: I18n.t(
      'page.advertise.guidelines.advert_custom.short_description'
    ),
    content: (
      <AdvertContent
        type="custom"
        image="guidelines/examples/custom.jpg"
        examplesLink="http://wetransfer.info/advertgallery/set/VjJua3pnU0dpdDUzVTVqOXRCQU1KQT09"
        checklistItems={[
          I18n.t('page.advertise.guidelines.advert_custom.requirement_one'),
        ]}
      />
    ),
  },
];

const guidelines = () => (
  <div className="page-advertise page-advertise-guidelines">
    <div className="page-advertise-guidelines__intro">
      <h1>{I18n.t('page.advertise.guidelines.intro.title')}</h1>
      <p
        dangerouslySetInnerHTML={{
          __html: I18n.t('page.advertise.guidelines.intro.description'),
        }}
      />
    </div>

    <hr />
    <div
      className="page-advertise-guidelines__types-and-requirements"
      name="#types-and-requirements"
    >
      <h3>{I18n.t('page.advertise.guidelines.requirements.title')}</h3>
      {!Browser.isMobile ? (
        <p>{I18n.t('page.advertise.guidelines.requirements.description')}</p>
      ) : null}
      <div className="accordion-container">
        <Accordion items={ACCORDION_ITEMS} />
      </div>
    </div>

    <hr />
    <div className="page-advertise-guidelines__dodonts">
      <div className="page-advertise-guidelines__dos column">
        <h3>{I18n.t('page.advertise.guidelines.should_be.title')}</h3>
        <ul>
          <li>
            <h5>
              {I18n.t('page.advertise.guidelines.should_be.point_one.title')}
            </h5>
            <p>
              {I18n.t(
                'page.advertise.guidelines.should_be.point_one.description'
              )}
            </p>
          </li>
          <li>
            <h5>
              {I18n.t('page.advertise.guidelines.should_be.point_two.title')}
            </h5>
            <p>
              {I18n.t(
                'page.advertise.guidelines.should_be.point_two.description'
              )}
            </p>
          </li>
          <li>
            <h5>
              {I18n.t('page.advertise.guidelines.should_be.point_three.title')}
            </h5>
            <p>
              {I18n.t(
                'page.advertise.guidelines.should_be.point_three.description'
              )}
            </p>
          </li>
        </ul>
      </div>
      <div className="page-advertise-guidelines__donts column">
        <h3>{I18n.t('page.advertise.guidelines.shouldnt_be.title')}</h3>
        <ul>
          <li>
            <p>{I18n.t('page.advertise.guidelines.shouldnt_be.point_one')}</p>
          </li>
          <li>
            <p>{I18n.t('page.advertise.guidelines.shouldnt_be.point_two')}</p>
          </li>
          <li>
            <p>{I18n.t('page.advertise.guidelines.shouldnt_be.point_three')}</p>
          </li>
        </ul>
      </div>
    </div>

    <hr />
    <div className="page-advertise-guidelines__tools">
      <h3>{I18n.t('page.advertise.guidelines.tools.title')}</h3>
      <div className="tool">
        <h5>{I18n.t('page.advertise.guidelines.tools.resize.title')}</h5>
        <p>{I18n.t('page.advertise.guidelines.tools.resize.text')}</p>
        <a
          href="/docs/advertising/wetransfer-safearea.zip"
          rel="external"
          className="button button--enabled"
        >
          {I18n.t('page.advertise.guidelines.tools.html5.button')}
        </a>
      </div>
      <div className="tool">
        <h5>{I18n.t('page.advertise.guidelines.tools.html5.title')}</h5>
        <p>{I18n.t('page.advertise.guidelines.tools.html5.text')}</p>
        <a
          href="/docs/advertising/wetransfer-html5api.zip"
          rel="external"
          className="button button--enabled"
        >
          {I18n.t('page.advertise.guidelines.tools.resize.button')}
        </a>
      </div>
    </div>

    <hr />
    <div className="page-advertise-guidelines__useful-info">
      <h3>{I18n.t('page.advertise.guidelines.important_info.title')}</h3>
      <ul>
        <li>
          {I18n.t('page.advertise.guidelines.important_info.point_three')}
        </li>
        <li>{I18n.t('page.advertise.guidelines.important_info.point_four')}</li>
        <li>{I18n.t('page.advertise.guidelines.important_info.point_five')}</li>
      </ul>
    </div>

    {Browser.isMobile
      ? [<hr key="contactFormSeperator" />, <ContactSales key="contactForm" />]
      : null}
  </div>
);

export default guidelines;
